import { from, merge, Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { mergeMap } from 'rxjs';
import { StorageActions, StorageMsg } from 'src/core/engine';

import { STORAGE_KEY, UserActions } from '../user.actions';

export function resetUserState(action$: Observable<any>): Observable<Action> {
    const signOut$ = action$.pipe(ofType<UserActions>('User.SignOut'));
    const userReset$ = action$.pipe(ofType<UserActions>('User.Reset'));
    /**
     * Merge the streams to perform the sign-out on both
     */
    return merge(signOut$, userReset$).pipe(
        mergeMap(() =>
            from([
                StorageMsg(StorageActions.Delete, STORAGE_KEY),
                StorageMsg(StorageActions.DeleteCookie, STORAGE_KEY),
            ]),
        ),
    );
}
